
import React, { useState, useContext, useEffect,useCallback,useRef } from "react";
import {Modal,Col,InputGroup} from "reactstrap";

import UpdateNav from './nav_update.js';



function UpdateModalForm(props) {
    const { isOpen, closeModal } = props;  
   
    function handleCloseModal() {
      
        closeModal();
    }





    return (

        <React.Fragment>

            <Modal isOpen={isOpen} >
                <div className="modal-header">
                    <h5
                        className="modal-title mt-0"
                        id="myModalLabel"
                    >
                        Update Nav
                    </h5>
                    <button
                        type="button"
                        onClick={handleCloseModal}
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                    >
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div className="modal-body">
                <UpdateNav
                    show={true}
                    showOpenButton={false}
                    isModal ={true}
                    data={(props && props.data ? props.data : null)}
                    closeModal={handleCloseModal}
                  />
                </div>
                <div className="modal-footer">

                    <button
                        type="button"
                        onClick={handleCloseModal}
                        className="btn btn-secondary "
                        data-dismiss="modal"
                    >
                        Close
                    </button>
                   
                </div>
            </Modal>


        </React.Fragment >




    )

};

export { UpdateModalForm }